import React, { FC } from 'react'

import { IconCarerProps } from './IconCarer.types'
import * as Styled from './styles/IconCarer.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCarer: FC<IconCarerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCarerProps['size'],
  isResponsive = false,
}: IconCarerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M28.973 31.442a1.555 1.555 0 0 1-.178 3.1' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M29.105 31.462s-7.07-1.397-8.825-1.772c-1-.215-2.14-.548-3-.815a7.66 7.66 0 0 0-5.808.462C9.652 30.282 7.083 33 6.34 36.8m10.465-1.05s1.363-1.178 2.402-1.227c1.3-.063 9.37.02 9.608.022'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m30.25 32.422 10.032-4.5a1.908 1.908 0 0 1 2.413.708v0a1.9 1.9 0 0 1-.75 2.715c-4.447 2.25-16.865 8.75-17.643 9.083l-.217.087c-1 .377-2 .425-3.11.42H10.5'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M38.625 28.68a2.63 2.63 0 0 0-.297-1.227v0a1.907 1.907 0 0 0-2.413-.708l-9.225 4.25m5.918-2.733c.002-.424-.1-.843-.298-1.22v0a1.908 1.908 0 0 0-2.413-.707L21.88 30.02M5 35.46l7.46 7.447'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M30.875 21.105c-.855-4.963-3.683-7.52-6.832-7.52-3.15 0-6.06 2.555-6.918 7.52'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 5.125h4.18v4.18A4.18 4.18 0 1 1 24 5.125v0Z' stroke='#E60000' strokeLinecap='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCarer
